import React,{useState} from 'react';
import Search from './components/search';
import Content from './components/content';
import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";

const VocFutureReport = () => {
  const [roleUser, isAll] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.VOC_FUTURE
  );
  const [typeFuture, setTypeFuture] = useState(null);
  return (

        <div>
          <Search 
          roleUser= {roleUser}
          onTypeChange={setTypeFuture}
          />
          <Content 
          roleUser= {roleUser}
          typeFuture={typeFuture} 
          />
        </div>

  );
};

export default VocFutureReport;